module.exports = __webpack_public_path__ + "static/media/white-cellar-placuta.353d0fac.png";